import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import SiteLayout from "@/components/layout/SiteLayout";
import Directory from "@/pages/Directory";
import ActivityOverview from "@/pages/ActivityOverview";
import PhaseGuide from "@/pages/PhaseGuide";
import VolunteerFlow from "@/pages/VolunteerFlow";
import PrintableGuide from "@/pages/PrintableGuide";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          {/* Standalone print view (no site chrome so it prints cleanly) */}
          <Route path="/activities/:slug/organizer/print" element={<PrintableGuide mode="drop-in" />} />
          <Route element={<SiteLayout />}>
            {/* Landing = Choose an Activity grid */}
            <Route path="/" element={<Directory />} />
            <Route path="/activities" element={<Navigate to="/" replace />} />
            {/* Per-activity role choice */}
            <Route path="/activities/:slug" element={<ActivityOverview />} />
            {/* Organizer path goes straight into the Drop-in Station guide */}
            <Route path="/activities/:slug/organizer" element={<PhaseGuide mode="drop-in" />} />
            {/* Volunteer path */}
            <Route path="/activities/:slug/volunteer" element={<VolunteerFlow />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0D1B33",
            color: "#ffffff",
            border: "1px solid rgba(255,255,255,0.1)",
          },
        }}
      />
    </AppProvider>
  );
}

export default App;
